import { useMutation } from "@tanstack/solid-query";

import client from "../client.js";
import API from "../api.js";
import { Cart } from "../query/index.js";
import { DEFAULT_HEADERS } from "../const.js";

export type Input = NonNullable<Parameters<typeof API.update>[0]["attributes"]>;

export const mutation = useMutation(
  () => ({
    mutationFn: async (attributes: Input) => {
      const cart = Cart.get();
      const response = await API.update(
        {
          note: cart?.note,
          attributes,
        },
        { headers: DEFAULT_HEADERS },
      );

      if (response.error) {
        throw response.error;
      }

      return response.data;
    },
    async onMutate(attributes) {
      await Cart.cancel();
      const previousCart = Cart.get();

      Cart.set((old) => ({
        ...old,
        attributes: {
          ...old.attributes,
          ...attributes,
        },
      }));

      return { previousCart };
    },
    onSettled() {
      Cart.invalidate();
    },
  }),
  () => client,
);
